
import {authorize} from "../../helper/authorize-token";
import superagent from "superagent";


const loadUserPersonalData = (token, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/personal-info")
      .send({username})
      .use(authorize(token))
      .then(res => {
        resolve(res.body.data);
      })
  })
};

const saveUserPersonalData = (token, data) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dashboard/personal-info")
      .use(authorize(token))
      .send( { data } )
      .then(res => {
        resolve(res.body.data);
      })
  })
};

export { loadUserPersonalData, saveUserPersonalData };
